import { Box, Dialog, DialogContent } from "@mui/material";
import StyledButtonV2 from "../../../../components/app/StyledButtonV2";
import Text from "../../../../components/Text";

interface DownloadZipModalProps {
  isModalOpen: boolean;
  setIsModal: (setVal: boolean) => void;
  message?: string;
}
const DownloadZipModal = ({
  isModalOpen = false,
  setIsModal,
  message,
}: DownloadZipModalProps) => {
  return (
    <Dialog
      open={isModalOpen}
      PaperProps={{
        sx: {
          borderRadius: "4px",
          padding: "24px",
          textAlign: "center",
          minWidth: "320px",
          maxHeight: "400px",
        },
      }}
    >
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Box
          sx={{
            width: 60,
            height: 60,
            borderRadius: "50%",
            background:
              "conic-gradient(from 90deg, #104E84 0deg, #FFFFFF 360deg)",
            mask: "radial-gradient(farthest-side, transparent calc(100% - 9px), #000 calc(100% - 9px))",
            WebkitMask:
              "radial-gradient(farthest-side, transparent calc(100% - 9px), #000 calc(100% - 9px))",
            position: "relative",
            animation: "spin 1s linear infinite",
            "&::after": {
              content: '""',
              position: "absolute",
              bottom: 0,
              left: "50%",
              transform: "translateX(-50%)",
              width: 9,
              height: 9,
              borderRadius: "50%",
              backgroundColor: "#104E84",
            },
            "@keyframes spin": {
              "0%": { transform: "rotate(0deg)" },
              "100%": { transform: "rotate(360deg)" },
            },
          }}
        />
        <Text color={"#101828"} fontWeight="500" size={"16px"} sx={{ mt: 1 }}>
          {message || "Please set the message for dialog"}
        </Text>
        <StyledButtonV2
          label="Okay"
          variant="contained"
          onClick={() => setIsModal(false)}
          sx={{
            mt: 1,
            textTransform: "none",
            borderRadius: "4px",
            fontSize: "14px",
            color: "#FFFFFF",
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default DownloadZipModal;
